// 設備類型選擇器組件
export default function DeviceTypeSelector({
  iconMapping,
  onSelect,
  onClose,
  deviceTypes,
}) {
  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold mb-4 text-white">選擇設備類型</h3>
        <div className="grid grid-cols-1 gap-3">
          {deviceTypes.map((deviceType) => {
            const Icon = iconMapping[deviceType.icon];
            return (
              <button
                key={deviceType.id}
                onClick={() => onSelect(deviceType)}
                className={`
                  flex items-center gap-3 p-3 rounded-lg border-2 text-left 
                  hover:scale-105 transition-all duration-200 
                `}
                style={{
                  borderColor: deviceType.color,
                }}
              >
                <Icon />
                <div className="flex-1">
                  <div className="font-medium text-white">
                    {deviceType.category_name}
                  </div>
                  <div className="text-sm text-gray-300">{deviceType.note}</div>
                </div>
              </button>
            );
          })}
        </div>
        <button
          onClick={onClose}
          className="mt-4 w-full px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded text-white transition-colors"
        >
          取消
        </button>
      </div>
    </div>
  );
}
